<template>
    <div class="sc05">
        <div class="inner01">
            <h3><span class="tit-st"><b>데이터</b>로 분석한</span> 구정</h3>
            <a :href="$_WC.cp + 'read'" class="btn-more">더보기</a>
            <div class="data-sgC mt-10" style="overflow: hidden;">
                <div class="read-swiper-container">
                    <div class="swiper-wrapper">

                        <div v-for="(read, index) in readList"
                            class="sgC datasungun swiper-slide"
                                :style="'background: #0d213b url(' + getImgUrl(read) + ') 1px 50% no-repeat; background-size: 100%;'">
                            <a :href="$_WC.cp + 'read?id=' + read.val1">
                                <p class="tit" v-html="setRead(read)"></p>
                                <p class="txt" v-html="setReadSub(read)"></p>
                            </a>
                        </div>

                    </div>
                    <div class="btn_pre swiper-button-prev pc-visible"></div>
                    <div class="btn_nxt swiper-button-next pc-visible"></div>
                    <div class="swiper_page mt-20 swiper-pagination"></div>
                </div>
            </div>
        </div>

        <div class="inner02">
            <h3>공공데이터</h3>
            
            <!-- <a :href="$_WC.cp + 'openapi'" class="datalink_bnr">
                <p class="txt"><b>공공데이터 분야별</b> 연계정보</p>
            </a> -->
            <!-- <a v-for="(rd, index) in openapiGridData" :key="index" 
                :href="$_WC.cp + 'openapi?code=' + rd.val3" :class="rd.val3 == '01' ? 'datalink_bnr': 'dataerrsch_bnr'">
                <p class="txt" v-if="rd.val3 == '01'"><b>공공데이터 분야별</b> 연계정보</p>
                <p class="txt" v-if="rd.val3 == '02'">잘못된 <b>공공데이터</b>를<br>찾아주세요</p>
                <p class="txt2" v-if="rd.val3 == '02'">2023년 7월 ~ 9월</p>
            </a> -->
            
            <div class="data-sgC mt-10" style="overflow: hidden;">
                <div class="read-swiper-container2">
                    <div class="swiper-wrapper">

                        <div v-for="(rd, index) in openapiGridData"
                            class="sgC datasungun swiper-slide"
                                :style="'background: #0d213b url(' + getImgUrl(rd) + ') 1px 50% no-repeat; background-size: 100%;'"
                                :key="index"
                                :href="$_WC.cp + 'openapi?code=' + rd.val3">
                            <a :href="$_WC.cp + 'openapi?code=' + rd.val3">
                                <p class="tit" v-if="rd.val3 == '01'">{{ rd.val2 }}</p>
                                <p class="txt2" v-if="rd.val3 == '02'">잘못된 <b>공공데이터</b>를<br>찾아주세요</p>
                                <p class="txt3" v-if="rd.val3 == '02'">2023년 7월 ~ 9월</p>
                                <!-- <p class="txt">{{ read.val5 }}</p> -->
                            </a>
                        </div>

                    </div>
                    <div class="btn_pre swiper-button-prev2 pc-visible" style="top: 40%" v-if="openapiGridData.length > 1"></div>
                    <div class="btn_nxt swiper-button-next2 pc-visible" style="top: 40%" v-if="openapiGridData.length > 1"></div>
                    <div class="swiper_page mt-20 swiper-pagination2"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import commonConstMixin from "@/stores/common.const.mixin.js";
import Swiper from '@/assets/js/swiperjs/swiper-bundle.js';
import {$_TYPE, $_WC} from '@/confs/common.const.js';
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            swiper: undefined,
            openapiSwiper: undefined,
        }
    },
    computed:{
        ...mapGetters({
            readList: 'getReadList',
            openapiGridData: 'getOpenapiGridData',
        }),
    },
    created() {
    },
    watch: {
        readList: {
            immediate: false,
            handler (newVal, oldVal) {
                this.$nextTick(()=> {
                    if(typeof this.swiper === $_TYPE.UNDEF) {
                        this.setSwiper();
                    }
                });
            }
        },
        openapiGridData: {
            immediate: false,
            handler (newVal, oldVal) {
                this.$nextTick(()=> {
                    if(typeof this.openapiSwiper === $_TYPE.UNDEF) {
                        this.setOpenapiSwiper();
                    }
                });
            }
        },
    },
    methods: {
        setSwiper(){
            const _this = this;
            this.swiper = new Swiper('.read-swiper-container', {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView : 1,
                // effect : 'coverflow',
                pagination: {
                    el: '.swiper-pagination'
                },
                mousewheel: true,
                keyboard: true,
                loop: true,
                spaceBetween: 30,
                autoplay: {
                    delay: 5000,
                },
                on: {
                    touchMove(){
                        _this.$eventBus.$emit("Swiper::touch-move");
                    },
                },
                breakpoints: {
                    3800: {
                        spaceBetween: 60,
                    },
                },
            });
        },
        setOpenapiSwiper(){
            const _this = this;
            this.openapiSwiper = new Swiper('.read-swiper-container2', {
                navigation: {
                    nextEl: '.swiper-button-next2',
                    prevEl: '.swiper-button-prev2',
                },
                slidesPerView : 1,
                // effect : 'coverflow',
                pagination: {
                    el: '.swiper-pagination2'
                },
                mousewheel: true,
                keyboard: true,
                loop: false,
                spaceBetween: 30,
                autoplay: {
                    delay: 5000,
                },
                autoHeight: true,
                on: {
                    touchMove(){
                        _this.$eventBus.$emit("Swiper::touch-move");
                    },
                },
                breakpoints: {
                    3800: {
                        spaceBetween: 60,
                    },
                },
            });
        },
        getImgUrl(data) {
            let returnUrl = '';
            if(typeof data.dataFiles !== $_TYPE.UNDEF && data.dataFiles.length > 0) {
                let file = data.dataFiles[0];
                returnUrl = $_WC.fileBaseURL + '/image/' + file.comnFlSqno;
            }
            return returnUrl;
        },
        setRead(read) {
            if(read.val1 == '1') {
                read.val2 = '도시 구석구석을 파악하는<br />스마트 강남';
                return read.val2;
            } else if(read.val1 == '2') {
                read.val2 = '남녀노소라면 누구나 <br />일할 수 있는 강남';
                return read.val2;
            } else if(read.val1 == '3') {
                read.val2 = '도시 곳곳 주차 공간이 마련된<br />편리한 강남';
                return read.val2;
            } else if(read.val1 == '4') {
                read.val2 = '자연 친화적이고 지구를 <br />생각하는 강남'
                return read.val2;
            } else if(read.val1 == '5') {
                read.val2 = '흥겨운 축제와 다채로운 관광 명소<br /> 문화 강남';
                return read.val2;
            } else {
                return read.val2;
            }
        },
        setReadSub(read) {
            if(read.val1 == '5') {
                read.val5 = '최고의 스타들이 펼치는 화려한 공연! 영동대로 K-POP 콘서트';
                return read.val5;
            } else {
                return read.val5;
            }
        },
    },
    mixins: [commonConstMixin],
};
</script>

<style>
</style>
